import * as React from 'react';
import { Form as AriaForm } from 'react-aria-components';

const Form = (props: React.ComponentPropsWithRef<typeof AriaForm>) => {
  return <AriaForm {...props} />;
};

Form.displayName = 'Form';
export default Form;
